(function () {
  console.log('[infinite-scroll] script loaded');

  const grid = document.getElementById('product-grid');
  console.log('[infinite-scroll] grid:', grid);
  if (!grid) return;

  function getNextUrl(root) {
    const next = root.querySelector('.pagination__list a[aria-label="Next page"]');
    return next ? next.getAttribute('href') : null;
  }

  let nextUrl = getNextUrl(document);
  console.log('[infinite-scroll] nextUrl:', nextUrl);
  if (!nextUrl) return;

  let loading = false;

  async function loadMore() {
    if (loading || !nextUrl) return;
    loading = true;
    console.log('[infinite-scroll] fetching', nextUrl);

    try {
      const res = await fetch(nextUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = doc.querySelectorAll('#product-grid > li');
      console.log('[infinite-scroll] items found:', items.length);

      items.forEach((item) => grid.appendChild(document.importNode(item, true)));
      nextUrl = getNextUrl(doc);
      console.log('[infinite-scroll] next after this:', nextUrl);
    } catch (e) {
      console.error('[infinite-scroll] failed', e);
    } finally {
      loading = false;
      check();
    }
  }

  function check() {
    if (loading || !nextUrl) return;
    const rect = grid.getBoundingClientRect();
    if (rect.bottom < window.innerHeight + 600) {
      loadMore();
    }
  }

  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  check(); // in case the first page doesn't fill the screen
})();